function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "yn4m949xla",
  d: "m21.359 7.216-1.585-1.588-6.284 6.293-6.284-6.293L5.62 7.216l6.284 6.292-6.284 6.293 1.585 1.587 6.284-6.293 6.284 6.293 1.585-1.587-6.284-6.293z"
}));
var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(.497 .503)",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("mask", {
  id: "6mwzdndj2b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#yn4m949xla"
})), /*#__PURE__*/React.createElement("g", {
  mask: "url(#6mwzdndj2b)",
  fill: "#FFF"
}, /*#__PURE__*/React.createElement("path", {
  d: "M-14.614-14.634h56.208V41.65h-56.208z"
})));
const SvgIconLiveIcClear = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 28,
  height: 28,
  viewBox: "0 0 28 28",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2);
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconLiveIcClear, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-live-ic-clear.442b60a0.svg";
export { ForwardRef as ReactComponent };